import { render, staticRenderFns } from "./processManage.vue?vue&type=template&id=2d7ad8e8"
import script from "./processManage.vue?vue&type=script&lang=js"
export * from "./processManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7ad8e8')) {
      api.createRecord('2d7ad8e8', component.options)
    } else {
      api.reload('2d7ad8e8', component.options)
    }
    module.hot.accept("./processManage.vue?vue&type=template&id=2d7ad8e8", function () {
      api.rerender('2d7ad8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/processManage.vue"
export default component.exports